import { Fragment, useMemo } from 'react';
import Stack from '@mui/material/Stack';
// @ts-ignore
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material';
import Chip from '../../Chip';
import styles from '../Autocomplete.module.css';

export interface SelectedValuesProps {
    value: any | any[];
    multiple?: boolean;
    placeholder?: string;
    getOptionLabel: (option: string) => string;
    handleDelete: (value: any) => void;
}

const DeleteIcon = styled(CloseIcon)(() => ({
    fill: 'black',
    width: '18px',
    height: '18px',
}));

export default function SelectedValues({
    value = [],
    multiple,
    placeholder,
    getOptionLabel,
    handleDelete,
}: SelectedValuesProps) {
    const onDelete = (value: string) => {
        return () => {
            handleDelete(value);
        };
    };
    const displayChips = useMemo(() => {
        if (multiple) {
            const n = value.length;
            const nExtra = n - 3;

            if (n === 0) {
                return placeholder ? <Chip label={placeholder} /> : <div />;
            }

            if (n > 3) {
                return (
                    <Fragment>
                        {value.slice(0, 3).map((v: string, i: number) => (
                            <Chip
                                key={i}
                                label={getOptionLabel(v)}
                                deleteIcon={<DeleteIcon />}
                                onDelete={onDelete(v)}
                            />
                        ))}
                        <Chip label={`+ ${nExtra} more...`} />
                    </Fragment>
                );
            }

            return value.map((v: string, i: number) => (
                <Chip key={i} label={getOptionLabel(v)} deleteIcon={<DeleteIcon />} onDelete={onDelete(v)} />
            ));
        }
        return (
            <Chip
                label={value ? getOptionLabel(value) : placeholder}
                deleteIcon={<DeleteIcon />}
                onDelete={onDelete(value)}
            />
        );
    }, [value, multiple, getOptionLabel, placeholder]);

    return (
        <Stack spacing={1} className={styles.selectedValueStack}>
            {displayChips}
        </Stack>
    );
}
